export const selectlist = {
  root: {
    transitionDuration: "{form.field.transition.duration}",
  },
  list: {
    gap: "{gap.16}",
  },
  item: {
    borderRadius: "{content.border.radius}",
    gap: "{gap.10}",
    padding: "{padding.16}",
    background: "{surface.bg-white}",
    borderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    borderWidth: "{border.width.1}",
    activeOutlineWidth: "{border.width.2}",
    focusOutlineWidth: "{border.width.2}",
  },
  label: {
    fontSize: "{typography.table.heading.font.size}",
    fontLeading: "{typography.table.heading.font.leading}",
    fontWeight: "{typography.table.heading.font.weight}",
    color: "{typography.table.heading.color}",
  },
  description: {
    fontSize: "{typography.body.text.regular.font.size}",
    fontLeading: "{typography.body.text.regular.font.leading}",
    fontWeight: "{typography.body.text.regular.font.weight}",
    color: "{text.caption}",
  },
};
